import { AttributeType, MetaData } from '..';

export class AttributeTypeDto {
  constructor(public metadata: MetaData, public results: AttributeType[]) {}
}
